

import Vue from 'vue'

import App from './App.vue'
import { routes } from "./routes/index";
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'






Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueRouter)


Vue.config.productionTip = false
const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL
});

new Vue({
  render: h => h(App),
  router,  
}).$mount('#app')
